const menuData = [
  {
    name: "Monsters",
    items: [
      { name: "Monster Kitkat", price: 140 },
      { name: "Monster Mississippi", price: 140 },
      { name: "Monster Chocolate", price: 140 },
      { name: "Monster Vanilla", price: 140 },
      { name: "Monster Strawberry", price: 140 },
      { name: "Monster Nutella", price: 140 },
      { name: "Monster Oreo", price: 140 },
      { name: "Monster Black Currant", price: 140 },
      { name: "Monster Dryfruit", price: 140 },
      { name: "Monster Butter Scotch", price: 140 },
    ],
  },
  {
    name: "Sundaes",
    items: [
      { name: "Dryfruit", price: 120 },
      { name: "Guava", price: 120 },
      { name: "Triple", price: 150 },
      { name: "Traffic Jam", price: 250 },
      { name: "Watermelon", price: 300 },
    ],
  },
  {
    name: "Sandwich",
    items: [
      { name: "Veg", price: 70 },
      { name: "Paneer", price: 80 },
      { name: "Schezwan", price: 80 },
      { name: "Cheese Corn", price: 120 },
      { name: "Mushroom", price: 120 },
      { name: "Bombay Pizza", price: 120 },
      { name: "Sandwich", price: 130 },
    ],
  },
  {
    name: "Burger",
    items: [
      { name: "Veg", price: 70 },
      { name: "Veg Schezwan", price: 80 },
      { name: "Paneer", price: 90 },
      { name: "Paneer Schezwan", price: 100 },
      { name: "Cheese Extra", price: 20 },
    ],
  },
  {
    name: "Pizza (4 Pieces / 6 Pieces)",
    items: [
      { name: "Paneer (4/6)", price: "180/240" },
      { name: "Cheese Burst (4/6)", price: "180/240" },
      { name: "Veg Burst (4/6)", price: "180/240" },
      { name: "Mushroom (4/6)", price: "180/240" },
      { name: "Sweet Corn (4/6)", price: "180/240" },
      { name: "Margherita (4/6)", price: "180/240" },
      { name: "Indiana Extra (4/6)", price: "180/240" },
      { name: "Cheese (4/6)", price: "50/50" },
    ],
  },
  {
    name: "Fries",
    items: [
      { name: "Plain Fries", price: 80 },
      { name: "Peri Peri Fries", price: 90 },
      { name: "Barbeque Honey Mustard Fries", price: 150 },
      { name: "Cheese Extra", price: 50 },
    ],
  },
  {
    name: "Hot Bytes",
    items: [
      { name: "Cheese Chips", price: 120 },
      { name: "Cheese Paneer Tikka", price: 130 },
      { name: "Cheese Mushroom Tikka", price: 130 },
      { name: "Veg Momos", price: 80 },
      { name: "Cheese Corn Momos", price: 120 },
      { name: "Paneer Momos", price: 120 },
      { name: "Corn Momos", price: 120 },
    ],
  },
  {
    name: "Nuggets",
    items: [
      { name: "Veg", price: 80 },
      { name: "Smiley", price: 80 },
      { name: "Cheese Corn", price: 90 },
      { name: "Chilly Garlic Pops", price: 90 },
    ],
  },
  {
    name: "Ice Creams",
    items: [
      { name: "Fruit Salad with Ice Cream", price: 60 },
      { name: "Brownie with Ice Cream", price: 70 },
      { name: "Chocolate Fudge", price: 70 },
      { name: "Butter Scotch Fudge", price: 120 },
      { name: "Death by Chocolate", price: 120 },
      { name: "Lychee with Ice Cream", price: 120 },
      { name: "Gudbud", price: 120 },
      { name: "Fruit Overload", price: 120 },
      { name: "Nutella Fudge", price: 120 },
      { name: "Nutella Brownie", price: 120 },
      { name: "Nutella Chocolate", price: 120 },
      { name: "Nutella Lychee", price: 120 },
      { name: "Nutella Butter Scotch", price: 120 },
      { name: "Nutella KitKat", price: 120 },
      { name: "Dilkush", price: 120 },
      { name: "Tiramisu", price: 120 },
      { name: "Hot Sizzlers", price: 150 },
      { name: "Nutella Gudbud", price: 150 },
    ],
  },
  {
    name: "Mojito",
    items: [
      { name: "Watermelon", price: 60 },
      { name: "Pineapple", price: 60 },
      { name: "Blue Lime", price: 60 },
      { name: "Orange", price: 70 },
      { name: "Strawberry", price: 70 },
      { name: "BlueBerry", price: 80 },
      { name: "Lychee", price: 80 },
      { name: "Tender Coconut", price: 80 },
    ],
  },
  {
    name: "Healthy Juice",
    items: [
      { name: "Carrot Apple Pineapple (CAP)", price: 90 },
      { name: "Apple Beetroot Carrot (ABC)", price: 90 },
    ],
  },
  {
    name: "Juices",
    items: [
      { name: "Fresh Lime", price: 40 },
      { name: "Apple", price: 50 },
      { name: "Moosambi", price: 50 },
      { name: "Musk Melon", price: 50 },
      { name: "Ginger Lime", price: 50 },
      { name: "Jaljeera", price: 50 },
      { name: "Pineapple", price: 50 },
      { name: "Moroccan Mint Lime", price: 50 },
      { name: "Lime Soda", price: 50 },
      { name: "Masala Soda", price: 50 },
      { name: "Watermelon", price: 50 },
      { name: "Orange", price: 60 },
      { name: "Blue Lime", price: 60 },
      { name: "Carrot Ginger Lime", price: 60 },
      { name: "Berry Pepper Shot", price: 60 },
      { name: "Pomegranate", price: 70 },
    ],
  },
  {
    name: "Bottle Smoothie",
    items: [
      { name: "Banana", price: 90 },
      { name: "Mango", price: 90 },
      { name: "Strawberry", price: 90 },
      { name: "Blueberry", price: 120 },
    ],
  },
  {
    name: "Thick Shakes",
    items: [
      { name: "Blue Berry Twist", price: 100 },
      { name: "Blue Berry Dryfruit", price: 100 },
      { name: "Blue Berry Lychee", price: 100 },
      { name: "Lychee and Mango", price: 100 },
      { name: "Nutella Shake", price: 100 },
      { name: "Kitkat Breakers", price: 100 },
      { name: "Cashew Shake", price: 100 },
      { name: "Frozen Bourbon", price: 100 },
    ],
  },
  {
    name: "Lassi",
    items: [
      { name: "Sweet", price: 40 },
      { name: "Banana", price: 40 },
      { name: "Mango", price: 50 },
      { name: "Fruit", price: 50 },
      { name: "Banana Mango", price: 50 },
      { name: "Saffron", price: 70 },
      { name: "Dry Fruit", price: 70 },
    ],
  },
  {
    name: "Falooda",
    items: [
      { name: "Plain", price: 70 },
      { name: "Kesar", price: 90 },
      { name: "Kulfi", price: 90 },
      { name: "Rose", price: 90 },
      { name: "Delhi Style", price: 120 },
      { name: "Royal", price: 150 },
      { name: "Arabian", price: 180 },
      { name: "Mango", price: 180 },
    ],
  },
  {
    name: "Protein",
    items: [
      { name: "Natural", price: 90 },
      { name: "Whey", price: 120 },
    ],
  },
  {
    name: "Special Icecream",
    items: [
      { name: "Gulkan", price: 120 },
      { name: "Gudbud", price: 180 },
      { name: "Death by Chocolate", price: 180 },
    ],
  },
  {
    name: "Cold Coffee",
    items: [
      { name: "Rock Coffee", price: 50 },
      { name: "Coffee on the Ice", price: 60 },
      { name: "Maafia", price: 90 },
      { name: "Cold Mud Coffee", price: 90 },
      { name: "Ferrero Coffee", price: 120 },
      { name: "Belgium Coffee", price: 120 },
    ],
  },
  {
    name: "Shakes",
    items: [
      { name: "Belgium Chocolate", price: 50 },
      { name: "Banana Beater Twisted", price: 50 },
      { name: "Strawberry", price: 50 },
      { name: "Mango Alphonso", price: 50 },
      { name: "Banana", price: 50 },
      { name: "Chickoo", price: 50 },
      { name: "Musk Melon", price: 50 },
      { name: "Ferrero Rocher", price: 60 },
      { name: "Tropical Mix Fruit", price: 60 },
      { name: "Kesar Pista", price: 60 },
      { name: "Green Pista", price: 60 },
      { name: "Vanilla", price: 60 },
      { name: "Belgium Choco Chips", price: 70 },
      { name: "Body Cooler", price: 70 },
      { name: "Boost Shake", price: 90 },
      { name: "Banana Boost", price: 90 },
      { name: "Banana Horlicks", price: 90 },
      { name: "Mango Strawberry", price: 90 },
      { name: "Mississippi Mud", price: 90 },
      { name: "Butter Scotch Choco Chips", price: 90 },
      { name: "Oreo Shake", price: 90 },
      { name: "Dryfruit Shake", price: 90 },
      { name: "Banana Cherry", price: 90 },
      { name: "Sharja Shake", price: 90 },
      { name: "Tender Coconut", price: 90 },
      { name: "Horlicks Shake", price: 90 },
      { name: "Apple", price: 90 },
      { name: "Pomegranate", price: 90 },
      { name: "Kesar Badam", price: 90 },
      { name: "Bubble Gum", price: 90 },
    ],
  },
  {
    name: "Combos",
    items: [
      { name: "Sandwich Combo (Loaded Sandwich, Peri Peri Fries, Refreshing Mojito)", price: 129 },
      { name: "Burger Combo (Juicy Burger, Peri Peri Fries, Refreshing Mojito)", price: 149 },
      { name: "Pizza Combo (4-Piece Pizza, Peri Peri Fries, Refreshing Mojito)", price: 249 },
    ],
  },
];

export default menuData; 